<template>
  <v-app>
    <v-app-bar app flat class="guest-appbar">
      <v-container fluid class="d-flex align-center py-0">
        <router-link to="/" class="d-flex align-center guest-logo-link">
          <img src="/images/myschlogo.png" alt="MYSCH" height="36" class="guest-logo" />
        </router-link>

        <v-spacer></v-spacer>

        <!-- Desktop nav -->
        <div class="d-none d-sm-flex align-center">
          <router-link :to="{ name: 'MultiAccessLogin' }" class="guest-nav-link">
            <v-icon small left>mdi-account-school-outline</v-icon>
            Teacher / Student Access
          </router-link>
          <router-link :to="{ name: 'Login' }" class="guest-nav-link">
            <v-icon small left>mdi-shield-account-outline</v-icon>
            School Admin Login
          </router-link>
          <v-btn :to="{ name: 'Register' }" color="primary" rounded depressed class="font-weight-bold text-none ml-2">
            <v-icon left small>mdi-rocket-launch-outline</v-icon>
            Register School
          </v-btn>
        </div>

        <!-- Mobile nav -->
        <v-menu offset-y left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" class="d-flex d-sm-none">
              <v-icon>mdi-menu</v-icon>
            </v-btn>
          </template>
          <v-list dense nav>
            <v-list-item :to="{ name: 'Register' }">
              <v-list-item-icon><v-icon small>mdi-rocket-launch-outline</v-icon></v-list-item-icon>
              <v-list-item-title>Register School</v-list-item-title>
            </v-list-item>
            <v-list-item :to="{ name: 'Login' }">
              <v-list-item-icon><v-icon small>mdi-shield-account-outline</v-icon></v-list-item-icon>
              <v-list-item-title>School Admin Login</v-list-item-title>
            </v-list-item>
            <v-list-item :to="{ name: 'MultiAccessLogin' }">
              <v-list-item-icon><v-icon small>mdi-account-school-outline</v-icon></v-list-item-icon>
              <v-list-item-title>Teacher / Student Access</v-list-item-title>
            </v-list-item>
            <v-list-item :to="{ name: 'RecoverPassword' }">
              <v-list-item-icon><v-icon small>mdi-lock-reset</v-icon></v-list-item-icon>
              <v-list-item-title>Recover Password</v-list-item-title>
            </v-list-item>
            <v-divider class="my-1"></v-divider>
            <v-list-item to="/">
              <v-list-item-icon><v-icon small>mdi-home-outline</v-icon></v-list-item-icon>
              <v-list-item-title>Back to Website</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-container>
    </v-app-bar>

    <v-main class="guest-shell">
      <div class="guest-blob guest-blob-1"></div>
      <div class="guest-blob guest-blob-2"></div>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'GuestLayout',
};
</script>

<style scoped>
.guest-appbar {
  background: rgba(255, 255, 255, 0.85) !important;
  backdrop-filter: blur(12px);
  border-bottom: 1px solid #ECEFF7;
}
.guest-logo-link {
  text-decoration: none;
}
.guest-logo {
  display: block;
}
.guest-nav-link {
  display: inline-flex;
  align-items: center;
  color: #44546E;
  text-decoration: none;
  font-weight: 600;
  font-size: 0.875rem;
  margin-right: 24px;
  transition: color 0.2s ease;
}
.guest-nav-link:hover,
.guest-nav-link.router-link-active {
  color: #1E3C72;
}
.guest-shell {
  position: relative;
  overflow: hidden;
  background: linear-gradient(135deg, #F4F6FB 0%, #E8ECF7 100%);
}
.guest-blob {
  position: absolute;
  border-radius: 50%;
  filter: blur(90px);
  opacity: 0.35;
  z-index: 0;
  pointer-events: none;
}
.guest-blob-1 {
  width: 420px;
  height: 420px;
  background: #2A5298;
  top: -140px;
  right: -100px;
}
.guest-blob-2 {
  width: 360px;
  height: 360px;
  background: #FFD54F;
  bottom: -120px;
  left: -90px;
}
</style>
